import styled from 'styled-components';
import { space } from 'components/foundations/variables';

const FooterWrapper = styled('div')`
  margin-top: ${space.xxl}px;
`;

export default FooterWrapper;
